import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { heroChips, heroTrust } from '../data/hero';
export function Hero() {
  return <header className="bg-radial-glow relative overflow-hidden" data-id="element-85" data-mp="ei1unjxvvyww">
      <div className="mx-auto max-w-4xl px-5 pb-6 pt-[15px] text-center" data-id="element-86" data-mp="9lbgx39jxfen">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="text-[10px] font-extrabold uppercase tracking-[0.25em] text-gold" data-id="element-87" data-mp="4mi5rhhqm0hn">
          🏆 SIGMA SMART™
        </motion.p>

        <p className="mx-auto mt-3 max-w-2xl font-display text-[22px] font-bold leading-tight text-white sm:text-[30px]" style={{
        color: "#D4AF37"
      }} data-id="element-88" data-mp="sai5h6x1118d">
          Elite Grades. Zero Burnout. The Only System You'll Ever Need.
        </p>

        
        <p className="pb-[15px] font-display text-xs font-bold uppercase tracking-[0.3em] text-silver-deep sm:text-base" data-id="element-89" data-mp="3d2tm12xxw8bd">
          YOUR ENTIRE SEMESTER SOLVED FROM TODAY
        </p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="relative mx-auto w-full max-w-xl" data-id="element-90" data-mp="3j923fiwkdgsw">
          <div className="absolute inset-0 -z-10 mx-auto h-64 w-64 translate-y-6 rounded-full bg-gold/20 blur-3xl" aria-hidden="true" data-id="element-91" data-mp="3e95ztkrs3rdv" />
          <img src="https://cdn.magicpatterns.com/uploads/5vZQjExYewNGerjd5kRaDd/ChatGPT_Image_10_ago_2026,_18_39_32.png" alt="The Academic Edge — 12 volumes and 5 bonuses in digital format" width={1536} height={1024} className="animate-floaty mx-auto aspect-[3/2] w-full max-w-full rounded-2xl object-contain" data-id="element-92" data-mp="30h9blrt8e1mr" />
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.05
      }} className="mt-4 text-xs font-semibold uppercase tracking-[0.18em] text-white/50" data-id="element-93" data-mp="2vgu1d948xa90">
          The #1 system to pass every subject without retaking
        </motion.p>

        <div className="mt-8 flex flex-col items-center" data-id="element-94" data-mp="nbl4urpxgsdm">
          <CTAButton href="#value" data-id="element-95" data-mp="na08cwk1yzd4">See the offer</CTAButton>

          <p className="mx-auto mt-4 max-w-2xl text-[14px] text-white/70 sm:text-lg" data-id="element-96" data-mp="ibgnz0l3xvmv">
            Everything you need to study with a real method, retain information deeply and perform
            without mental blocks. No improvising. No wasting another year of your degree.
          </p>

          <motion.h2 initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="mx-auto mt-4 max-w-2xl text-[16px] font-bold text-silver sm:text-xl" data-id="element-97" data-mp="161b0fh1ili6l">
            Study Method · Retention · Organization · Anxiety Management · Performance
          </motion.h2>

          <div className="mt-6 flex flex-wrap justify-center gap-2.5" data-id="element-98" data-mp="3lqm4435bldx1">
            {heroChips.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5 rounded-full border border-white/10 bg-white/5 px-3.5 py-1.5 text-xs font-semibold text-white/80" data-id="element-99" data-mp="1xacer0y0hfs6">
                <Icon className="h-3.5 w-3.5 text-gold" data-id="element-100" data-mp="269hegalb7f5x" />
                {label}
              </span>)}
          </div>

          <p className="mt-4 text-sm font-semibold text-white/50" data-id="element-101" data-mp="2b1ram8d0pbgn">
            12 Volumes · 5 Bonuses · +100 pages — Everything solved.
          </p>
        </div>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-white/50" data-id="element-102" data-mp="2kyvmnfd5fqjq">
          {heroTrust.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-103" data-mp="2tzlfca7450t8">
              <Icon className="h-4 w-4 text-gold" data-id="element-104" data-mp="2txhek14ighx6" />
              {label}
            </span>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.05
      }} className="mt-5 inline-flex items-center gap-2 rounded-full border border-gold/50 bg-gold/10 px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-gold-soft" data-id="element-105" data-mp="uok99b2z950g">
          🔥 Launch offer ends soon · Price goes up to $50
        </motion.div>
      </div>
    </header>;
}